import { AbstractControl, ValidatorFn } from '@angular/forms'

export function SelectionLengthValidator(maxLength: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control.value) {
      return null
    }

    return control.value.length <= maxLength
      ? null
      : { tooManySelected: control.value.length }
  }
}
